export const verifyInactivityTimeoutMinutes = (input: number): boolean =>
  Number.isInteger(input) && input >= 5 && input <= 60;
